/* OXS Audio EU — Withdrawal function (two-step: capture → confirm → acknowledgement) */
(function () {
  'use strict';
  var root = document.getElementById('withdrawal');
  if (!root) return;
  var form = document.getElementById('withdrawal-form');
  var endpoint = (root.getAttribute('data-endpoint') || '').trim();
  var locale = root.getAttribute('data-locale') || 'en';
  var shop = root.getAttribute('data-shop') || '';
  var mailto = root.getAttribute('data-mailto') || '';
  var i18n = window.OXS_WITHDRAWAL_I18N || { labels: {}, subject: 'Withdrawal', declaration: '' };

  var steps = {
    1: form.querySelector('[data-step="1"]'),
    2: form.querySelector('[data-step="2"]'),
    done: form.querySelector('[data-step="done"]')
  };
  var inds = form.querySelectorAll('[data-step-ind]');
  var errors = {
    contract: form.querySelector('[data-error="contract"]'),
    fields: form.querySelector('[data-error="fields"]'),
    send: form.querySelector('[data-error="send"]')
  };
  var confirmBtn = form.querySelector('[data-action="confirm"]');

  function val(name) {
    var el = form.elements[name];
    return el ? String(el.value || '').trim() : '';
  }
  function data() {
    return {
      name: val('name'),
      email: val('email'),
      order_number: val('order_number'),
      order_date: val('order_date'),
      items: val('items'),
      message: val('message'),
      website: val('website'), // honeypot
      locale: locale,
      shop: shop,
      page: location.href,
      declaration: i18n.declaration
    };
  }
  function show(step) {
    Object.keys(steps).forEach(function (k) { if (steps[k]) steps[k].hidden = (k !== String(step)); });
    inds.forEach(function (li) {
      var n = Number(li.getAttribute('data-step-ind'));
      li.classList.toggle('is-active', step === n);
      li.classList.toggle('is-done', step === 'done' || (typeof step === 'number' && n < step));
    });
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function setInvalid(name, bad) {
    var el = form.elements[name];
    if (el) el.setAttribute('aria-invalid', bad ? 'true' : 'false');
  }
  function validate() {
    var d = data();
    var ok = true;
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(d.email);
    setInvalid('name', d.name.length < 2); if (d.name.length < 2) ok = false;
    setInvalid('email', !emailOk); if (!emailOk) ok = false;
    errors.fields.hidden = ok;
    var contractOk = !!(d.order_number || d.order_date);
    setInvalid('order_number', !contractOk); setInvalid('order_date', !contractOk);
    errors.contract.hidden = contractOk;
    return ok && contractOk;
  }
  function fmtDate(iso) {
    if (!iso) return '—';
    try { return new Date(iso + 'T00:00:00').toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' }); } catch (e) { return iso; }
  }
  function fillReview() {
    var d = data();
    form.querySelectorAll('[data-review]').forEach(function (dd) {
      var k = dd.getAttribute('data-review');
      var v = d[k];
      dd.textContent = k === 'order_date' ? fmtDate(v) : (v || '—');
    });
    // Prefill mailto fallback with the same declaration
    var body = [i18n.declaration, ''];
    ['name', 'email', 'order_number', 'order_date', 'items', 'message'].forEach(function (k) {
      if (d[k]) body.push((i18n.labels[k] || k) + ': ' + d[k]);
    });
    var a = form.querySelector('.withdrawal__mailto');
    if (a) a.href = 'mailto:' + mailto + '?subject=' + encodeURIComponent(i18n.subject) + '&body=' + encodeURIComponent(body.join('\n'));
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var act = btn.getAttribute('data-action');
    if (act === 'next') { if (validate()) { fillReview(); show(2); } }
    if (act === 'back') { errors.send.hidden = true; show(1); }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validate()) { show(1); return; }
    var d = data();
    if (d.website) return; // bot
    errors.send.hidden = true;
    if (!endpoint) { errors.send.hidden = false; return; }
    confirmBtn.disabled = true;
    confirmBtn.querySelector('[data-label]').hidden = true;
    confirmBtn.querySelector('[data-sending]').hidden = false;

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(d)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j || !res.j.ok) throw new Error((res.j && res.j.error) || 'send_failed');
        form.querySelector('[data-success="time"]').textContent = res.j.received_at_display || res.j.received_at;
        form.querySelector('[data-success="email"]').textContent = d.email;
        form.querySelector('[data-success="id"]').textContent = res.j.id || '';
        show('done');
      })
      .catch(function () {
        errors.send.hidden = false;
      })
      .finally(function () {
        confirmBtn.disabled = false;
        confirmBtn.querySelector('[data-label]').hidden = false;
        confirmBtn.querySelector('[data-sending]').hidden = true;
      });
  });
})();
